export * from './outlet.directive';
export * from './outlet.module';
